

module.exports = __webpack_require__.stylable.create(
    "Thumbnail1310007064",
    {"classes":{"root":"Thumbnail1310007064__root"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    2,
    "Thumbnail1310007064",
    null
);
